/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { SystemStyleObject, Theme } from "@mui/system";

export const promptGenerationStreamOutputStyles = {
  textArea: {
    whiteSpace: "normal",
    wordBreak: "break-word",
    fontSize: 14,
  } satisfies SystemStyleObject<Theme>,
  htmlText: {
    "& > :first-of-type": {
      mt: 0,
    },
    "& > :last-child": {
      mb: 0,
    },
    "& p": {
      my: 1,
    },
    "& ul, & ol": {
      my: 1,
      pl: 3,
    },
    "& li": {
      my: 0.25,
    },
  } satisfies SystemStyleObject<Theme>,
  shimmerEmptyText: {
    display: "inline-block",
    fontWeight: 700,
    color: "transparent",
    backgroundImage: (theme: Theme) =>
      `linear-gradient(
      100deg,
      ${theme.palette.grey[500]} 0%,
      ${theme.palette.grey[500]} 30%,
      ${theme.palette.primary.dark} 45%,
      ${theme.palette.common.white} 50%,
      ${theme.palette.primary.dark} 55%,
      ${theme.palette.grey[500]} 70%,
      ${theme.palette.grey[500]} 100%
    )`,
    backgroundSize: "320% 100%",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    animation: "legalbirdTextShimmer 5.1s linear infinite",

    "@keyframes legalbirdTextShimmer": {
      "0%": {
        backgroundPosition: "160% 0",
      },
      "100%": {
        backgroundPosition: "-160% 0",
      },
    },
  } satisfies SystemStyleObject<Theme>,
};
